import script from "./ModalMenuItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalMenuItem.vue?vue&type=script&setup=true&lang=js"

import "./ModalMenuItem.vue?vue&type=style&index=0&id=4cbe2ae2&lang=scss&scoped=true"

import exportComponent from "/Users/matteo.direnzo/Documents/TVA/eni-digit_eni-storia/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cbe2ae2"]])

export default __exports__